import { useState, useMemo } from 'react';
import { Menu, MenuItem, Button } from 'components/ui';
import { LanguageIcon } from 'components/uiIcons';
import { getDefaultLocale } from 'utils/locale';
import { ArrowDropDownIcon, ArrowDropUpIcon } from 'components/uiIcons';
import theme from 'theme';

const InternationalizationSwitch = () => {
  const [languageAnchorEl, setLanguageAnchorEl] = useState(null);
  const languageOpen = Boolean(languageAnchorEl);

  const handleLanguageClick = (event) => {
    setLanguageAnchorEl(event.currentTarget);
  };

  const handleLanguageClose = () => {
    setLanguageAnchorEl(null);
  };

  const setSelectedLanguage = (newLanguage) => {
    localStorage.setItem('locale', newLanguage);
    window.location.reload();
  };

  const icon = useMemo(() => {
    return languageOpen ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />;
  }, [languageOpen]);

  const selectedLanguage = localStorage.getItem('locale') || getDefaultLocale();

  return (
    <>
      <Button
        onClick={handleLanguageClick}
        sx={{
          backgroundColor: languageOpen ? theme.palette.custom.whiteGreen : 'transparent'
        }}>
        <LanguageIcon /> {selectedLanguage.toUpperCase()} {icon}
      </Button>
      <Menu anchorEl={languageAnchorEl} open={languageOpen} onClose={handleLanguageClose}>
        <MenuItem value="pl" onClick={() => setSelectedLanguage('pl')}>
          PL
        </MenuItem>
        <MenuItem value="en" onClick={() => setSelectedLanguage('en')}>
          EN
        </MenuItem>
      </Menu>
    </>
  );
};

export default InternationalizationSwitch;
